import { render, staticRenderFns } from "./MyStatementsPage.vue?vue&type=template&id=0371126e&"
import script from "./MyStatementsPage.vue?vue&type=script&lang=js&"
export * from "./MyStatementsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports